<template>
    <div>
        <button type="button" class="btn btn-sm ms-2" 
            :class="notes || parseInt(duration) ? 'btn-primary' : 'btn-outline-primary'" 
            @click="modal.show()"
        ><i class="far fa-sticky-note fa-lg"></i></button>
        <div class="modal" tabindex="-1" ref="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Notes</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <textarea class="form-control mb-2" 
                            v-model="notes"
                        ></textarea>
                        <div class="d-flex align-items-center">
                            <div class="flex-grow-1 text-end me-2">Duration</div>
                            <div class="input-group" style="width:10em;">
                                <input class="form-control d-inline-block w-50" type="number" min="0" max="480" step="1" aria-describedby="min-label"
                                    v-model="duration"
                                />
                                <span class="input-group-text" id="min-label">mins</span>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <!-- <button type="button" class="btn btn-primary me-auto" :disabled="!notes" @click="intervention"><i class="fas fa-file-invoice"></i>&nbsp;Intervention</button> -->
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class="fas fa-ban"></i>&nbsp;Cancel</button>
                        <button type="button" class="btn btn-primary" @click="update"><i class="far fa-save"></i>&nbsp;Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Modal } from 'bootstrap';

export default {
    props: {
        value: {
            type: Object,
            default: function(data={}) {
                return {
                    notes: data.notes ?? '',
                    duration: data.duration ?? 0
                }
            }
        },
    },

    mounted() {
        this.modal = new Modal(this.$refs.modal);
    },
        
    data() {
        return {
            modal: null,

            notes: this.value.notes,
            duration: this.value.duration,
        }
    },

    watch: {
        value: function(n, o) {
            this.notes = n.notes ?? '';
            this.duration = n.duration ?? 0;
        }
    },

    methods: {
        update() {
            const data = {
                notes: this.notes,
                duration: this.duration,
            };
            this.$emit('input', data);
            this.modal.hide();
        },

        // intervention() {
        //     if (this.$parent.id) {
        //         window.open(`/intervention/${this.$parent.id}`);
        //     } else {
        //         console.warn('Assessment ID is not set. Cannot load intervention.');
        //     }            
        // },
    }
}
</script>